/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'embedded-confluence-common.src.content.empty-state-description': "Her yere baktık fakat bulamadık. Silinmiş olabilir. Tabii eğer URL'de bir yazım hatası yoksa 😉",
  'embedded-confluence-common.src.content.empty-state-header': 'Aradığınız bulunamadı',
  'embedded.confluence.already-logged-in-paragraph': 'Oturumunuz zaten açık mı? Sayfayı yenilemeyi deneyin.',
  'embedded.confluence.footer.hover.text': "Confluence'ta görüntüleyin",
  'embedded.confluence.footer.prefix': 'Sağlayan:',
  'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum aç",
  'embedded.confluence.login-page.login-button': "Confluence'ta oturum aç",
  'embedded.confluence.login-page.login-button.aria-label': 'Oturum Açma Düğmesi',
  'embedded.confluence.login-page.login-text': 'Bu sayfayı görüntülemek için oturum açmanız gerekir',
  'embedded.confluence.login-page.refresh-page-banner': 'Oturum açtıktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya tıklayarak yenileyebilirsiniz',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Sayfayı yenile',
  'embedded.confluence.need-to-log-in-paragraph': 'Bu sayfayı görüntülemek için oturum açmanız gerekir',
  'embedded.confluence.still-having-trouble-paragraph': 'Sorun yaşamaya devam mı ediyorsunuz? Üçüncü taraf çerezlerinin etkinleştirildiğinden emin olun ya da {link}',
  'embedded.confluence.troubleshooting-link-text': 'bu sorun giderme kılavuzuna başvurun',
  'embedded.confluence.troubleshooting-link.aria-label': 'sorun giderme kılavuzu bağlantısı'
};